
<h2 class="popup-heading" mat-dialog-title>Check Out Professional Plan</h2>
<div class="content content1">
    <h4>In order to use these features, please upgrade to Professional.</h4>
       <div class="goToBilling">
        <button mat-raised-button color="primary" (click)="goToBilling()" [ngStyle]="{ 'background-color': 'var(--primary-color)', 'color': 'var(--light-color)' }">Go to Billing.</button>
    </div>
</div>
